<div class="h-full overflow-y-auto pt-[36px] pr-24">
  <ion-header>
    <ion-toolbar *ngIf="!opened" class="w-[51px]">
      <img class="w-[51px] cursor-pointer" src="../../../../../assets/images/new_branding/logo_color.svg" alt="fundeen" (click)="navigateTo('portfolio')">
      <div *ngIf="hasRicEnergyLogo" class="border-t border-t-eggplant-100/[0.1] flex items-center justify-center">
        <img class="!h-[56px] pt-12" src="../../../../../assets/images/new_branding/ricenergy-v3.webp" alt="fundeen" (click)="navigateTo('portfolio')">
      </div>
    </ion-toolbar>
    <ion-toolbar *ngIf="opened" class="w-[184px]">
      <img src="../../../../../assets/images/new_branding/imagotipo_color.svg" alt="fundeen" class="cursor-pointer" (click)="navigateTo('portfolio')">
      <div *ngIf="hasRicEnergyLogo" class="border-t border-t-eggplant-100/[0.1]">
        <img src="../../../../../assets/images/new_branding/ricenergy.webp" alt="fundeen" class="cursor-pointer" (click)="navigateTo('portfolio')">
      </div>
    </ion-toolbar>
  </ion-header>
  <!-- TODO: Comentado temporalmente - la variable 'opened' se comparte con otros componentes y provoca aperturas/cierres erróneos -->
  <!-- <div *ngIf="!opened" class="flex justify-center mt-8">
    <div (click)="toggleMenu()" class="cursor-pointer p-4 rounded-xl hover:bg-eggplant-100/[.06] transition-colors">
      <fun-icon [name]="'menu'" [style]="'w-20 h-20 stroke-eggplant-80 stroke-2'"></fun-icon>
    </div>
  </div>
  <div *ngIf="opened" class="flex justify-end pr-8 mt-8">
    <div (click)="toggleMenu()" class="cursor-pointer p-4 rounded-xl hover:bg-eggplant-100/[.06] transition-colors">
      <fun-icon [name]="'chevron-left'" [style]="'w-20 h-20 stroke-eggplant-80 stroke-2'"></fun-icon>
    </div>
  </div> -->
  <div class="border-b border-b-eggplant-100/[.05] mx-4 mt-12"></div>
  <div class="pt-40 pb-32 flex cursor-pointer" (click)="navigateTo('my-profile')">
    <app-avatar *ngIf="nameUser && nameUser !== null && nameUser !== undefined"></app-avatar>
    <div *ngIf="opened" class="self-center">
      <p class="font-sans text-xl text-eggplant-80 pl-8" *ngIf="nameUser && nameUser !== null && nameUser !== undefined">{{ nameUser }}</p>
      <p class="font-sans text-s text-eggplant-80 opacity-55 pl-8 truncate max-w-[120px]" *ngIf="emailUser && opened">{{ emailUser }}</p>
      <p class="font-sans text-xl text-eggplant-80 pl-8 relative cursor-pointer" (click)="completeProfile()" *ngIf="nameUser === ''">
        <span class="absolute top-2 -right-28 w-[16px] h-[16px]"><span class="animate-ping absolute top-[3px] inline-flex h-full w-full rounded-full bg-pink-100 opacity-75"></span><span class="relative inline-flex rounded-full w-[16px] h-[16px] mb-[6px] linear-gradient-2"></span></span>
        {{ 'REGISTER.MY_PROFILE.COMPLETE_PROFILE' | translate }}
      </p>
    </div>
  </div>
  <div class="flex flex-col pb-64">
    <div *ngFor="let option of menuList">
      <div (click)="navigateTo(option.path)"
           (mouseenter)="showTooltip($event, option.title)"
           (mouseleave)="hideTooltip()"
           class="flex mb-12 cursor-pointer rounded-2xl"
           [ngClass]="{'linear-gradient-2': option.selected, 'no-selected': !option.selected}">
        <div>
          <div class="self-center">
            <fun-sidemenu-icon [icon]="option.icon" [selected]="option.selected"></fun-sidemenu-icon>
          </div>
        </div>
        <div *ngIf="opened" class="self-center">
          <p class="font-sans text-h300 pl-12" [ngClass]="{'text-eggplant-100': !option.selected, 'text-white': option.selected}">{{ option.title }}</p>
        </div>
      </div>
    </div>
    <div class="border-t border-t-eggplant-100/[.05] my-12"></div>
    <div (click)="navigateTo('configuration')"
         (mouseenter)="showTooltip($event, 'MENU.CONFIGURATION')"
         (mouseleave)="hideTooltip()"
         class="flex mb-12 cursor-pointer rounded-2xl"
         [ngClass]="{'linear-gradient-2': configSelected, 'no-selected': !configSelected}">
      <div class="self-center">
        <div class="rounded-2xl w-56 h-56 flex items-center justify-center">
          <img src="../../../../../assets/images/new_branding/settings.svg" alt="fundeen"/>
        </div>
      </div>
      <div *ngIf="opened" class="self-center">
        <p class="font-sans text-h300 pl-12 cursor-pointer" [ngClass]="{'text-eggplant-100': !configSelected, 'text-white': configSelected}">{{ 'MENU.CONFIGURATION' | translate }}</p>
      </div>
    </div>
  </div>

  <div *ngIf="tooltipItem && !opened"
       class="fixed font-sans text-s rounded shadow-l py-4 px-8 bg-eggplant-100 text-cream-100 whitespace-nowrap pointer-events-none"
       style="z-index: 9999; transform: translateY(-50%)"
       [style.top.px]="tooltipItem.top"
       [style.left.px]="tooltipItem.left">
    {{ tooltipItem.title }}
  </div>
</div>
